import React from 'react';
import enhance from './Campaign.enhancer';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { campaignStatuses, contentTypes } from '../../constants';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { getCountryValueFromKey } from '../../helpers/countryHelper';
import HpTooltip from '../../components/shared/components/hpTooltip';

class Campaign extends React.Component {
  constructor() {
    super();

    this.initialState = {
      dealCheckComplete: false,
      isPaymentEntryModalOpen: false,
      showRetireConfirmationDialog: false,
      campaignIdToDelete: null
    };

    this.state = {
      ...this.initialState
    };
  }

  propseDealClick() {
    if (
      this.props.profile.paypalInfo &&
      this.props.profile.paypalInfo.payerId
    ) {
      const influencerId = this.props.auth.uid;
      const companyId = this.props.campaign.companyId;
      const campaignId = this.props.campaign.id;

      if (influencerId && companyId && campaignId) {
        this.props.proposeDealFromInfluencerClick();
      }
    } else {
      this.setState({
        isPaymentEntryModalOpen: true
      });
    }
  }

  navigateToSettings() {
    this.props.history.push(`/settings`);
  }

  handleClosePaymentModal() {
    this.setState({
      isPaymentEntryModalOpen: false
    });
  }

  handleCloseRetireModal() {
    this.setState({
      showRetireConfirmationDialog: false
    });
  }

  handleRetireCampaignClick(campaignId) {
    this.setState({
      showRetireConfirmationDialog: true,
      campaignIdToDelete: campaignId
    });
  }

  confirmRetireCamapign() {
    this.props.retireCampaignClickHandler(this.state.campaignIdToDelete);

    this.setState({
      showRetireConfirmationDialog: false,
      campaignIdToDelete: null
    });
  }

  render() {
    const {
      classes,
      profile,
      campaign,
      dealCheckComplete,
      isDealInProgressForCampaign
    } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.root}>
          <Grid container direction="column">
            <Grid container direction="row">
              <Grid item sm={8}>
                <Grid container direction="row">
                  <img src={campaign.picUrl} className={classes.image} />
                  <div>
                    <Typography variant="h5">{campaign.name}</Typography>
                    <Typography>
                      Created on{' '}
                      {campaign.createdAt
                        ? moment(campaign.createdAt.toDate()).format(
                            'MM/DD/YYYY'
                          )
                        : ''}{' '}
                      by {campaign.companyName}
                    </Typography>
                    <React.Fragment>
                      {campaign.status === campaignStatuses.ACTIVE && (
                        <Typography className={classes.activeText}>
                          Active
                        </Typography>
                      )}
                      {campaign.status === campaignStatuses.RETIRED && (
                        <Typography className={classes.retiredText}>
                          Retired
                        </Typography>
                      )}
                      {campaign.status === campaignStatuses.PENDING && (
                        <Typography className={classes.retiredText}>
                          Pending
                        </Typography>
                      )}
                    </React.Fragment>
                  </div>
                </Grid>
              </Grid>
              <Grid align="right" sm={4}>
                {!profile.isCompany &&
                  dealCheckComplete &&
                  !isDealInProgressForCampaign &&
                  campaign.status !== campaignStatuses.RETIRED && (
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.interestedButton}
                      onClick={this.props.proposeDealClickHandler}
                    >
                      Propose Deal
                    </Button>
                  )}
                {!profile.isCompany &&
                  dealCheckComplete &&
                  isDealInProgressForCampaign &&
                  campaign.status !== campaignStatuses.RETIRED && (
                    <Button
                      variant="outlined"
                      color="primary"
                      className={classes.interestedSentButton}
                    >
                      Interest Sent!
                    </Button>
                  )}
                {profile.isCompany &&
                  campaign.status !== campaignStatuses.RETIRED && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      className={classes.retireButton}
                      onClick={() =>
                        this.handleRetireCampaignClick(campaign.id)
                      }
                    >
                      Retire Campaign
                    </Button>
                  )}
              </Grid>
            </Grid>
            <Grid />
            <Grid item sm={12} className={classes.paragraph}>
              <Typography variant="body1" className={classes.paragraph}>
                {campaign.description}
              </Typography>
              {campaign.contentType === contentTypes.OTHER && (
                <React.Fragment>
                  <Typography variant="h6" className={classes.paragraph}>
                    Custom Content Requirement:
                  </Typography>
                  <Typography variant="body1">
                    {campaign.otherContentDetails}
                  </Typography>
                </React.Fragment>
              )}
            </Grid>
            <Grid container direction="row">
              {campaign.contentType && (
                <Grid sm={2} className={classes.propertyItem} align="center">
                  {campaign.contentType === contentTypes.REVIEW && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Review
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to revewing your experience with the product or service.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaign.contentType === contentTypes.GAMEPLAY && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Gameplay
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video of you playing the game and giving your own positive commentary.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaign.contentType === contentTypes.MENTION && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Mention
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'An endorsement during a video encouraging viewers to use the service, buy the product, or check out the website.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaign.contentType === contentTypes.TUTORIAL && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Mention
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to walking viewers through how to use the product or service and why they should buy it.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaign.contentType === contentTypes.UNBOXING && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Unboxing
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={
                          'A video dedicated to giving a first impression of unpacking the product on camera and why the viewer should buy it.'
                        }
                      />
                    </React.Fragment>
                  )}
                  {campaign.contentType === contentTypes.OTHER && (
                    <React.Fragment>
                      <Typography variant="h6" display="inline">
                        Other
                      </Typography>
                      <HpTooltip
                        styling={{
                          marginLeft: '5px',
                          marginBottom: '3px'
                        }}
                        message={'See above for description of the content.'}
                      />
                    </React.Fragment>
                  )}
                  <Typography variant="body1">Content Type</Typography>
                </Grid>
              )}
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.ageMin} - {campaign.ageMax}
                </Typography>
                <Typography variant="body1">Ages</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {`$${campaign.payoutMin &&
                    campaign.payoutMin.toLocaleString()} - $${campaign.payoutMax &&
                    campaign.payoutMax.toLocaleString()}`}
                </Typography>
                <Typography variant="body1">Payout</Typography>
              </Grid>

              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {(campaign.productAndCommission || campaign.productOnly) &&
                    `Yes`}
                  {!campaign.productAndCommission &&
                    !campaign.productOnly &&
                    'No'}
                </Typography>
                <Typography variant="body1">Recieve Product</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.shippableProduct && `Yes`}
                  {!campaign.shippableProduct && 'No'}
                </Typography>
                <Typography variant="body1">Shippable Product</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.duration && `${campaign.duration}`}
                  {!campaign.duration && 'Any'}
                </Typography>
                <Typography variant="body1">Duration</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.country && `${campaign.country}`}
                  {!campaign.country && 'Any'}
                </Typography>
                <Typography variant="body1">Location</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.gender && `${campaign.gender}`}
                  {!campaign.gender && 'Any'}
                </Typography>
                <Typography variant="body1">Gender</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.productCategory && `${campaign.productCategory}`}
                  {!campaign.productCategory && 'Any'}
                </Typography>
                <Typography variant="body1">Industry</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.influenceLevel === 'micro' && `Micro (100+)`}
                  {campaign.influenceLevel === 'macro' && `Macro (10,000+)`}
                  {campaign.influenceLevel === 'mega' && `Mega (100,000+)`}
                </Typography>
                <Typography variant="body1">Influence Level</Typography>
              </Grid>
              <Grid sm={2} className={classes.propertyItem} align="center">
                <Typography variant="h6">
                  {campaign.isPrivate && 'Yes'}
                  {!campaign.isPrivate && 'No'}
                </Typography>
                <Typography variant="body1">Is Private</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        {(campaign.productUrl || campaign.productPhotoUrl) && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <Typography variant="h4" align="left">
                Product
              </Typography>
              {campaign.productPhotoUrl && (
                <div className={classes.productContainer}>
                  <img
                    src={campaign.productPhotoUrl}
                    className={classes.productPhoto}
                  />
                </div>
              )}
              {campaign.productUrl && (
                <Typography className={classes.productContainer} variant="h5">
                  <a
                    className={classes.productContainer}
                    href={`${
                      campaign.productUrl.indexOf('http://') === 0 ||
                      campaign.productUrl.indexOf('https://') === 0
                        ? campaign.productUrl
                        : '//' + campaign.productUrl
                    }`}
                    target="_blank"
                  >
                    Check out the product!
                  </a>
                </Typography>
              )}
            </Grid>
          </Paper>
        )}
        {campaign.goals && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <div>
                <Typography variant="h4">Campaign Goals</Typography>
              </div>
              <div className={classes.goalsContainer}>
                <Typography>{campaign.goals}</Typography>
              </div>
            </Grid>
          </Paper>
        )}
        {campaign.brandStory && (
          <Paper className={`${classes.root} ${classes.paperSection}`}>
            <Grid container direction="column">
              <div>
                <Typography variant="h4">Brand Story</Typography>
              </div>
              <div className={classes.brandStoryContainer}>
                <Typography>{campaign.brandStory}</Typography>
              </div>
            </Grid>
          </Paper>
        )}
        <Dialog
          id="payment-info-dialog"
          open={this.state.isPaymentEntryModalOpen}
          onClose={this.props.handleClose}
          disableAutoFocus={true}
          onBackdropClick={this.handleClosePaymentModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              maxWigth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="h6" align="center" justify="center">
            Set up your payment info before sending your interest to a campaign!
          </Typography>
          <Typography variant="body1" align="center" justify="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.paymentButton}
              onClick={this.navigateToSettings.bind(this)}
            >
              Payment Settings
            </Button>
          </Typography>
        </Dialog>
        <Dialog
          id="delete-account-dialog"
          open={this.state.showRetireConfirmationDialog}
          onClose={this.props.handleCloseRetireModal}
          // classes={classes.modalStyles}
          disableAutoFocus={true}
          onBackdropClick={this.handleCloseRetireModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="body1" align="center">
            Are you sure you want to retire this campaign?
          </Typography>
          <Typography variant="body1" align="center">
            (Active deals for this campaign will be unaffected)
          </Typography>
          <div className={classes.deleteButtonsContainer}>
            <Button
              color="secondary"
              onClick={this.handleCloseRetireModal.bind(this)}
              fullWidth
              className={classes.deleteCancelButtons}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={this.confirmRetireCamapign.bind(this)}
              fullWidth
              className={classes.deleteAcceptButtons}
            >
              Retire
            </Button>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default enhance(Campaign);



// WEBPACK FOOTER //
// ./src/components/campaign/CampaignDetails.js